/*
* Description: Static Application Information
*
* History:
*   05/05/2023  A Kuprion   ITMFG-31548 Initial version, needed because package.json can no longer be read
*
**/
export const appinfo = {
    'name': 'scportal',
    'version': '1.0.0'
}